import ee from 'event-emitter';

let emitter = ee({});

export default emitter;


// WEBPACK FOOTER //
// ./src/scripts/Trail/emitter.js